import { render, staticRenderFns } from "./time-tab.vue?vue&type=template&id=4423192b&"
import script from "./time-tab.vue?vue&type=script&lang=ts&"
export * from "./time-tab.vue?vue&type=script&lang=ts&"
import style0 from "./time-tab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports